import axios from 'axios'
import { ElMessage } from 'element-plus'
import { getToken, removeToken } from '@/utils/auth'
import { getApiBaseUrl } from '@/utils/serviceBase'

axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'

const service = axios.create({
  baseURL: getApiBaseUrl(),
  timeout: 60000
})

service.interceptors.request.use(
  config => {
    const token = getToken()
    if (token) {
      config.headers['Authorization'] = 'bearer ' + token
    }
    return config
  },
  error => Promise.reject(error)
)

service.interceptors.response.use(
  res => {
    const code = res.data.code
    const shouldSilent = Boolean(res.config?.silentError)

    if (code !== 1) {
      if (!shouldSilent) {
        ElMessage.error(res.data.mess)
      }
      return Promise.reject(res.data)
    }

    return Promise.resolve(res.data.data)
  },
  error => {
    console.log('err', error)
    const shouldSilent = Boolean(error?.config?.silentError)
    if (!shouldSilent) {
      ElMessage.error(error?.message || '操作失败')
    }
    if (error?.response?.status === 401) {
      removeToken()
      window.location = '/login'
    }

    return Promise.reject(error)
  }
)

export default service
